import { GallerySkeletonCard } from './gallery-skeleton-card';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function GallerySkeletonStructure() {
  return (
    <div
      className={cn(
        'custom-container',
        'grid grid-cols-1 gap-6 sm:grid-cols-2 md:gap-8 lg:grid-cols-3',
      )}
    >
      <GallerySkeletonCard />
      <GallerySkeletonCard />
      <GallerySkeletonCard />
      <GallerySkeletonCard />
      <GallerySkeletonCard />
      <GallerySkeletonCard />
      <GallerySkeletonCard />
      <GallerySkeletonCard />
      <GallerySkeletonCard />
    </div>
  );
}
